import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import logoImage from '../images/logo.svg'

const HeaderWrapper = styled.div`
  height: 66px;
`

const Header = styled.header`
  background: #fff;
  width: 100%;
  position: fixed;
  z-index: 9999;

  a {
    display: block;
    width: 46px;
    height: 46px;
    margin: 10px auto;
  }
`

// const activeLinkStyle = {
//   color: 'white',
// }

const AppHeader = () => {
  return (
    <HeaderWrapper>
      <Header>
        <Link to="/">
          <img src={logoImage} alt="Inutuna" />
        </Link>
      </Header>
    </HeaderWrapper>
  )
}

export default AppHeader
